import React, { useContext } from 'react'
import { Form, Button, Row, Col, Tabs, Tab, Card, InputGroup, Accordion, AccordionContext, AccordionToggle, Dropdown } from 'react-bootstrap'
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrash, faPlus, faChevronUp, faChevronDown, faCopy } from '@fortawesome/free-solid-svg-icons'
import TextareaAutosize from 'react-textarea-autosize';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import { v4 as uuidv4 } from 'uuid';
import { useAccordionToggle } from 'react-bootstrap/AccordionToggle';
import Node from './node';

function ExportTab({state, exportConfigurations, exportDocumentTypes, exportDocumentConfigurations, handleChange}) {

	const {t} = useTranslation('common')

	const addTemplateExportConfiguration = (e, exportConfiguration) => {
		e.preventDefault()

		var position = 0
        state.templateExportConfigurations.forEach(templateExportConfiguration => {
            position = Math.max(position, templateExportConfiguration.position)
        })

		var templateExportConfiguration = {
            id: uuidv4(),
            customerId: state.customerId,
            exportConfiguration: exportConfiguration.id,
            name: "",
            position: position + 1,
            params: { exportAutomatically: false, exportAutomaticallyTrigger: '', unselectedByDefault: false },
            nodes: [],
            preconditions: []
        }

        if (exportConfiguration.type == "EMAIL") {
            templateExportConfiguration.params.subject = ""
            templateExportConfiguration.params.body = ""
        }

		var newTemplateExportConfigurations = [...state.templateExportConfigurations, templateExportConfiguration]

		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
	}

	const removeTemplateExportConfiguration = (e, templateExportConfiguration) => {
        e.preventDefault()

		let newTemplateExportConfigurations = state.templateExportConfigurations.filter(other => other.id != templateExportConfiguration.id)

        handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const copyTemplateExportConfiguration = (e, templateExportConfiguration) => {
        e.preventDefault()

		var position = 0
        state.templateExportConfigurations.forEach(templateExportConfiguration => {
            position = Math.max(position, templateExportConfiguration.position)
        })

		var templateExportConfigurationCopy = {
            id: uuidv4(),
            customerId: templateExportConfiguration.customerId,
            exportConfiguration: templateExportConfiguration.exportConfiguration,
            name: templateExportConfiguration.name,
            position: position + 1,
            params: {...templateExportConfiguration.params},
            nodes: [],
            preconditions: []
        }

        templateExportConfiguration.nodes.forEach(node => {
            var nodeCopy = deepCopyNode(node)
	        templateExportConfigurationCopy.nodes.push(nodeCopy)
        })

        templateExportConfiguration.preconditions.forEach(precondition => {
            var preconditionCopy = {
	            id: uuidv4(),
	            customerId: precondition.customerId,
	            type: precondition.type,
	            params: {...precondition.params}
	        }
			templateExportConfigurationCopy.preconditions.push(preconditionCopy)
        })

		var newTemplateExportConfigurations = [...state.templateExportConfigurations, templateExportConfigurationCopy]

        handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

	const addNode = (e, templateExportConfiguration, parent, type) => {
        e.preventDefault()

        var node = {
            id: uuidv4(),
            customerId: state.customerId,
            type: type,
            position: 0,
            params: {},
            children: []
        }

        if (type == "ZIP_FILE") {
            node.params.name = "{DOCUMENTATION_NAME}.zip"
        } else if (type != 'PHOTOS' && type != 'FILES' && type != 'EXTERNAL_FILES') {
            node.params.name = ""
        }

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]

        if (parent) {
            node.parent = parent.id
            parent.children.push(node)

            parent.children.forEach((sibling, index) => {
	            sibling.position = index
	        })
        } else {
            var maxIndex = -1
            templateExportConfiguration.nodes.forEach((root, index) => {
                root.position = index
	            maxIndex = index
	        })
	        node.position = maxIndex + 1

	        node.templateExportConfiguration = templateExportConfiguration.id

	        templateExportConfiguration.nodes.push(node)
        }

        handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const removeNode = (e, templateExportConfiguration, parent, node) => {
        e.preventDefault()

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]

        if (parent) {
            parent.children = parent.children.filter(child => child.id != node.id)

            parent.children.forEach((child, index) => {
	            child.position = index
	        })
        } else {
            templateExportConfiguration.nodes = templateExportConfiguration.nodes.filter(child => child.id != node.id)
            templateExportConfiguration.nodes.forEach((root, index) => {
                root.position = index
	        })
        }

        handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const copyNode = (e, templateExportConfiguration, parent, node) => {
        e.preventDefault()

        var nodeCopy = deepCopyNode(node)

        if (parent) {
            //nodeCopy.parent = parent.id
            parent.children.push(nodeCopy)

            parent.children.forEach((sibling, index) => {
	            sibling.position = index
	        })
        } else {
            var maxIndex = -1
            templateExportConfiguration.nodes.forEach((root, index) => {
                root.position = index
	            maxIndex = index
	        })
	        nodeCopy.position = maxIndex + 1

	        //node.templateExportConfiguration = templateExportConfiguration.id

	        templateExportConfiguration.nodes.push(nodeCopy)
        }

        let newTemplateExportConfigurations = [...state.templateExportConfigurations]
        handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const handleNameChange = (e, templateExportConfiguration) => {
        console.log('handleNameChange ' + e.target.name + ', ' + e.target.value)

		templateExportConfiguration.name = e.target.value
		let newTemplateExportConfigurations = [...state.templateExportConfigurations]
		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const handleParamsChange = (e, templateExportConfiguration) => {
        console.log('handleParamsChange ' + e.target.name + ', ' + e.target.value + ', ' + e.target.checked)

        if (e.target.type === 'checkbox') {
			templateExportConfiguration.params[e.target.name] = e.target.checked
		} else {
			templateExportConfiguration.params[e.target.name] = e.target.value
		}

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]
		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const handleNodeParamsChange = (e, node) => {
        console.log('handleNodeParamsChange ' + e.target.name + ', ' + e.target.value + ', ' + e.target.checked)

        if (e.target.type === 'checkbox') {
			node.params[e.target.name] = e.target.checked
		} else {
			node.params[e.target.name] = e.target.value
		}

		console.log(node.params)

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]
		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const filterExportConfigurations = () => {
		return exportConfigurations.filter(exportConfiguration => {
			return exportConfiguration.customerId == state.customerId
		})
    }

    function ContextAwareToggle({ eventKey, callback }) {
		const currentEventKey = useContext(AccordionContext);

		const decoratedOnClick = useAccordionToggle(
			eventKey,
			() => callback && callback(eventKey),
		);

		const isCurrentEventKey = currentEventKey === eventKey;

		return (
			<Button onClick={decoratedOnClick} variant="outline">
			    <FontAwesomeIcon icon={isCurrentEventKey ? faChevronUp : faChevronDown}/>
			</Button>
		)
	}

	const addPrecondition = (templateExportConfiguration) => {
        let precondition = {
            id: uuidv4(),
            customerId: templateExportConfiguration.customerId,
            type: 'TASK_ANSWER',
            position: 0,
            params: {
                TASK_ID: '',
                OPERATOR: 'EQUALS',
                ANSWER: ''
            }
        }
		templateExportConfiguration.preconditions.push(precondition)

		templateExportConfiguration.preconditions.forEach((precondition, index) => {
			precondition.position = index
		})

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]
		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const removePrecondition = (templateExportConfiguration, precondition) => {
        var index = templateExportConfiguration.preconditions.indexOf(precondition)
        templateExportConfiguration.preconditions.splice(index, 1)

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]
		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const copyPrecondition = (templateExportConfiguration, precondition) => {
        var preconditionCopy = {
            id: uuidv4(),
            customerId: precondition.customerId,
            type: precondition.type,
            position: 0,
            params: {...precondition.params}
        }
        templateExportConfiguration.preconditions.push(preconditionCopy)

        templateExportConfiguration.preconditions.forEach((precondition, index) => {
			precondition.position = index
		})

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]
		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const handlePreconditionTypeChanges = (precondition, e) => {
        console.log('handlePreconditionTypeChanges')

        precondition.type = e.target.value
        precondition.params = {}
        //precondition.params.TASK_ID = ''
        if (precondition.type == 'TASK_ANSWER') {
            precondition.params.OPERATOR = 'EQUALS'
            precondition.params.ANSWER = ''
        }

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]
		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const handlePreconditionParamChanges = (precondition, e) => {
        console.log('handlePreconditionParamChanges')

        precondition.params[e.target.name] = e.target.value

		let newTemplateExportConfigurations = [...state.templateExportConfigurations]
		handleChange({target: {type: "object", name: "templateExportConfigurations", value: newTemplateExportConfigurations}})
    }

    const deepCopyNode = node => {
        var nodeCopy = {
            id: uuidv4(),
            customerId: node.customerId,
            type: node.type,
            position: node.position,
            params: {...node.params},
            children: []
        }

        node.children.forEach(child => {
            var childCopy = deepCopyNode(child)
            nodeCopy.children.push(childCopy)
        })

        return nodeCopy
    }

	return (
		<>
			{ exportConfigurations.length > 0 &&
				<Row>
					{ state.templateExportConfigurations.map(templateExportConfiguration => {
						const exportConfiguration = exportConfigurations.find(exportConfiguration => exportConfiguration.id == templateExportConfiguration.exportConfiguration)
	                    return <Col md="4" key={templateExportConfiguration.id}>
		                    <Card>
		                        <Card.Body>
			                        <div className="clearfix">
										<div className="float-left">
											<h4>
				                                { exportConfiguration.name }
				                            </h4>
										</div>
										<div className="float-right">
											<Button
									            onClick={(e) => copyTemplateExportConfiguration(e, templateExportConfiguration)}
									            title={t("crudtable.delete.button")}
									            size="sm"
									            color="info"
									            variant="outline-primary"
									            style={{marginRight: 5}}>
									            <FontAwesomeIcon icon={faCopy}/>
									        </Button>
											<Button
									            onClick={(e) => removeTemplateExportConfiguration(e, templateExportConfiguration)}
									            title={t("crudtable.delete.button")}
									            size="sm"
									            color="info"
									            variant="outline-danger">
									            <FontAwesomeIcon icon={faTrash}/>
									        </Button>
										</div>
									</div>
		                            <div>
		                                <Form.Group controlId="name">
											<Form.Label>
							                    {t('templateexportconfiguration.columns.name')}
							                </Form.Label>
							                <Form.Control
							                    type="text"
							                    placeholder={t('templateexportconfiguration.columns.name')}
							                    name="name"
							                    value={templateExportConfiguration.name || ''}
							                    onChange={e => handleNameChange(e, templateExportConfiguration)}
							                />
						                </Form.Group>
						                <Form.Group controlId="unselectedByDefault" style={{marginBottom: 5}}>
			                                <Form.Check
			                                    id={'unselectedByDefault-' + templateExportConfiguration.id}
			                                    type="checkbox"
			                                    name="unselectedByDefault"
			                                    label={t('templateexportconfiguration.params.unselectedbydefault')}
			                                    checked={templateExportConfiguration.params.unselectedByDefault || false}
			                                    onChange={e => handleParamsChange(e, templateExportConfiguration)}
			                                />
										</Form.Group>
						                <Form.Group controlId="exportAutomatically">
			                                <Form.Check
			                                    id={'exportAutomatically-' + templateExportConfiguration.id}
			                                    type="checkbox"
			                                    name="exportAutomatically"
			                                    label={t('templateexportconfiguration.params.exportautomatically')}
			                                    checked={templateExportConfiguration.params.exportAutomatically || false}
			                                    onChange={e => handleParamsChange(e, templateExportConfiguration)}
			                                />
										</Form.Group>
										{ templateExportConfiguration.params.exportAutomatically &&
											<>
												<Form.Group controlId="exportAutomaticallyTrigger">
													<Form.Label>
									                    {t('templateexportconfiguration.params.exportautomaticallytrigger')}
									                </Form.Label>
					                                <Form.Control
					                                    required
					                                    as="select"
					                                    name="exportAutomaticallyTrigger"
					                                    value={templateExportConfiguration.params.exportAutomaticallyTrigger || 'COMPLETED'}
					                                    onChange={e => handleParamsChange(e, templateExportConfiguration)}
					                                >
					                                    <option value="PAUSED">{t('documentation.status.paused')}</option>
									                    <option value="COMPLETED">{t('documentation.status.completed')}</option>
									                </Form.Control>
												</Form.Group>
												<Form.Group controlId="preconditions">
													<Form.Label>
									                    {t('templateexportconfiguration.columns.preconditions')}
									                </Form.Label>
													{ templateExportConfiguration.preconditions.map((precondition, index) => {
														return <Accordion key={precondition.id} defaultActiveKey={precondition.dateCreated ? '' : '0'}>
															<Card>
																<Card.Header style={{padding: '0px', background: 'none'}}>
																	<div className="clearfix">
																		<div className="float-left" style={{padding: '5px 10px 5px 10px'}}>
																			{t('precondition.label')} {index + 1}
																		</div>
																		<div className="float-right">
																			<ContextAwareToggle eventKey="0"/>
																        </div>
																	</div>
																</Card.Header>
																<Accordion.Collapse eventKey="0">
																	<Card.Body>
																		<label>
																			{t('precondition.columns.type')}
																		</label>
																		<Form.Control required as="select" name="type" value={precondition.type} onChange={e => handlePreconditionTypeChanges(precondition, e)}>
														                    <option value="TASK_ANSWER">{t('precondition.types.taskanswer')}</option>
														                    <option value="TASK_PHOTOS_TAKEN">{t('precondition.types.taskphotostaken')}</option>
														                    <option value="TASK_NO_PHOTOS_TAKEN">{t('precondition.types.tasknophotostaken')}</option>
														                    <option value="TASK_FINISHED">{t('precondition.types.taskfinished')}</option>
														                    <option value="TASK_UNFINISHED">{t('precondition.types.taskunfinished')}</option>
														                </Form.Control>
														                { precondition.type == 'TASK_ANSWER' &&
														                    <>
														                        <label>
																					{t('precondition.params.task')}
																				</label>
																				<Form.Control required as="select" name="TASK_ID" value={precondition.params.TASK_ID} onChange={e => handlePreconditionParamChanges(precondition, e)}>
																                    <option value="">{t('precondition.choosetask')}</option>
																                    { state.tasks.filter(otherTask => ['TEXT', 'CHECKBOX', 'SINGLE_CHOICE', 'MULTI_CHOICE', 'INTEGER', 'DECIMAL', 'SINGLE_CHOICE_SUGGESTION', 'MULTI_CHOICE_SUGGESTION'].includes(otherTask.type)).map(task => {
																                        return <option value={task.id} key={task.id}>{task.name}</option>
																                    })}
																                </Form.Control>
																                <label>
																					{t('precondition.params.operator')}
																				</label>
																				<Form.Control required as="select" name="OPERATOR" value={precondition.params.OPERATOR} onChange={e => handlePreconditionParamChanges(precondition, e)}>
																                    <option value="EQUALS">{t('precondition.operators.equals')}</option>
																                    <option value="NOT_EQUALS">{t('precondition.operators.notequals')}</option>
																                </Form.Control>
																                <label>
																					{t('precondition.params.answer')}
																				</label>
																				<Form.Control required type="text" placeholder={t('precondition.params.answer')} name="ANSWER" value={precondition.params.ANSWER} onChange={e => handlePreconditionParamChanges(precondition, e)}/>
													                        </>
													                    }
													                    { (precondition.type == 'TASK_PHOTOS_TAKEN' || precondition.type == 'TASK_NO_PHOTOS_TAKEN') &&
														                    <>
														                        <label>
																					{t('precondition.params.task')}
																				</label>
																				<Form.Control required as="select" name="TASK_ID" value={precondition.params.TASK_ID} onChange={e => handlePreconditionParamChanges(precondition, e)}>
																                    <option value="">{t('precondition.choosetask')}</option>
																                    { state.tasks.filter(otherTask => otherTask.type == 'PHOTO').map(task => {
																                        return <option value={task.id} key={task.id}>{task.name}</option>
																                    })}
																                </Form.Control>
													                        </>
													                    }
													                    { (precondition.type == 'TASK_FINISHED' || precondition.type == 'TASK_UNFINISHED') &&
														                    <>
																                <label>
																					{t('precondition.params.task')}
																				</label>
																				<Form.Control required as="select" name="TASK_ID" value={precondition.params.TASK_ID} onChange={e => handlePreconditionParamChanges(precondition, e)}>
																                    <option value="">{t('precondition.choosetask')}</option>
																                    { state.tasks.filter(otherTask => !['GROUP', 'HEADER', 'STATIC_TEXT'].includes(otherTask.type)).map(task => {
																                        return <option value={task.id} key={task.id}>{task.name}</option>
																                    })}
																                </Form.Control>
													                        </>
													                    }
													                    <br/>
													                    <div>
													                        <Button
																	            onClick={(e) => copyPrecondition(templateExportConfiguration, precondition)}
																	            title={t("crudtable.copy.button")}
																	            color="info"
																	            variant="outline-primary"
																	            style={{ width: '50%' }}>
																	            <FontAwesomeIcon icon={faCopy}/> {t('precondition.copy')}
																	        </Button>
														                    <Button
																	            onClick={(e) => removePrecondition(templateExportConfiguration, precondition)}
																	            title={t("crudtable.delete.button")}
																	            color="info"
																	            variant="outline-danger"
																	            style={{ width: '50%' }}>
																	            <FontAwesomeIcon icon={faTrash}/> {t('precondition.delete')}
																	        </Button>
																        </div>
													                </Card.Body>
												                </Accordion.Collapse>
															</Card>
														</Accordion>
													})}
													<br/>
													<Button
									                    title={t('task.addprecondition')}
									                    onClick={e => addPrecondition(templateExportConfiguration)}
									                    color="info"
									                    variant="outline-primary">
									                    <FontAwesomeIcon icon={faPlus}/> {t('task.addprecondition')}
									                </Button>
								                </Form.Group>
											</>
										}
										{ exportConfiguration.type == 'EMAIL' &&
											<>
												<Form.Group controlId="subject">
													<Form.Label>
									                    {t('templateexportconfiguration.params.subject')}
									                </Form.Label>
										            <InputGroup>
										                <Form.Control
										                    type="text"
										                    placeholder={t('templateexportconfiguration.params.subject')}
										                    name="subject"
										                    value={templateExportConfiguration.params.subject || ''}
										                    onChange={e => handleParamsChange(e, templateExportConfiguration)}
										                />
						                                <Dropdown>
						                                    <Dropdown.Toggle variant="primary">
						                                    </Dropdown.Toggle>
							                                <Dropdown.Menu>
						                                        { ['DOCUMENTATION_NAME', 'TEMPLATE_NAME', 'CREATOR', 'EXPORT_DATE', 'EXPORT_TIME', 'DATE_CREATED', 'DATE_UPLOADED', 'TASK_ANSWER'].map(item => {
						                                            return <Dropdown.Item
						                                                key={item}
						                                                onClick={e => handleParamsChange({target: {name: 'subject', value: (templateExportConfiguration.params.subject || '') + '{' + item + '}'}}, templateExportConfiguration)}
						                                            >
						                                                {item}
						                                            </Dropdown.Item>
						                                        })}
															</Dropdown.Menu>
														</Dropdown>
									                </InputGroup>
								                </Form.Group>
												<Form.Group controlId="body">
													<Form.Label>
									                    {t('templateexportconfiguration.params.body')}
									                </Form.Label>
									                <InputGroup>
										                <Form.Control
										                    as="textarea"
										                    placeholder={t('templateexportconfiguration.params.body')}
										                    name="body"
										                    value={templateExportConfiguration.params.body || ''}
										                    rows={5}
										                    onChange={e => handleParamsChange(e, templateExportConfiguration)}
										                />
										                <Dropdown>
						                                    <Dropdown.Toggle variant="primary">
						                                    </Dropdown.Toggle>
							                                <Dropdown.Menu>
						                                        { ['DOCUMENTATION_NAME', 'TEMPLATE_NAME', 'CREATOR', 'EXPORT_DATE', 'EXPORT_TIME', 'DATE_CREATED', 'DATE_UPLOADED', 'TASK_ANSWER'].map(item => {
						                                            return <Dropdown.Item
						                                                key={item}
						                                                onClick={e => handleParamsChange({target: {name: 'body', value: (templateExportConfiguration.params.body || '') + '{' + item + '}'}}, templateExportConfiguration)}
						                                            >
						                                                {item}
						                                            </Dropdown.Item>
						                                        })}
															</Dropdown.Menu>
														</Dropdown>
									                </InputGroup>
												</Form.Group>
											</>
										}
		                            </div>
		                            <div>
		                                {t('templateexportconfiguration.nodes.label')}:
			                            { templateExportConfiguration.nodes.map(node => {
			                                return <Node
			                                    key={node.id}
			                                    node={node}
			                                    templateExportConfiguration={templateExportConfiguration}
			                                    exportConfiguration={exportConfiguration}
			                                    exportDocumentTypes={exportDocumentTypes}
			                                    exportDocumentConfigurations={exportDocumentConfigurations}
			                                    addNode={addNode}
			                                    removeNode={removeNode}
			                                    copyNode={copyNode}
			                                    handleNodeParamsChange={handleNodeParamsChange}
			                                />
			                            })}
		                            </div>
		                            <Dropdown>
							            <Dropdown.Toggle variant="outline-primary">
											{t('templateexportconfiguration.addnode')}
										</Dropdown.Toggle>
										<Dropdown.Menu style={{padding: '10px', minWidth: '300px'}}>
											{ ['SHAREPOINT', 'FTP', 'WEBDAV', 'STOREGATE'].includes(exportConfiguration.type) &&
												<Dropdown.Item onClick={e => addNode(e, templateExportConfiguration, null, 'FOLDER')}>
													{t('templateexportconfiguration.nodes.folder')}
												</Dropdown.Item>
											}
											<Dropdown.Item onClick={e => addNode(e, templateExportConfiguration, null, 'ZIP_FILE')}>
												{t('templateexportconfiguration.nodes.zipfile')}
											</Dropdown.Item>
											<Dropdown.Item onClick={e => addNode(e, templateExportConfiguration, null, 'PHOTOS')}>
												{t('templateexportconfiguration.nodes.photos')}
											</Dropdown.Item>
											<Dropdown.Item onClick={e => addNode(e, templateExportConfiguration, null, 'FILES')}>
												{t('templateexportconfiguration.nodes.files')}
											</Dropdown.Item>
											<Dropdown.Item onClick={e => addNode(e, templateExportConfiguration, null, 'EXTERNAL_FILES')}>
												{t('templateexportconfiguration.nodes.externalfiles')}
											</Dropdown.Item>
											<Dropdown.Item onClick={e => addNode(e, templateExportConfiguration, null, 'EXPORT_DOCUMENT_CONFIGURATION')}>
												{t('templateexportconfiguration.nodes.exportdocumentconfiguration')}
											</Dropdown.Item>
											<Dropdown.Item onClick={e => addNode(e, templateExportConfiguration, null, 'EXPORT_DOCUMENT_TYPE')}>
												{t('templateexportconfiguration.nodes.exportdocumenttype')}
											</Dropdown.Item>
										</Dropdown.Menu>
							        </Dropdown>
		                        </Card.Body>
		                    </Card>
		                </Col>
	                })}
				</Row>
			}
	        <Dropdown>
	            <Dropdown.Toggle variant="outline-primary">
					{t('template.addexportconfiguration')}
				</Dropdown.Toggle>
				<Dropdown.Menu style={{padding: '10px', minWidth: '300px'}}>
					{ filterExportConfigurations().map(exportConfiguration => {
						return <Dropdown.Item onClick={e => addTemplateExportConfiguration(e, exportConfiguration)} key={exportConfiguration.id}>
							{exportConfiguration.name}
						</Dropdown.Item>
					})}
				</Dropdown.Menu>
	        </Dropdown>
        </>
	)
}

export default ExportTab